import * as Sentry from '@sentry/vue'
// eslint-disable-next-line no-restricted-imports
import type { Router } from 'vue-router'

import { Mode } from '../types/environment'

/**
 * Вкл/выкл Sentry
 */
export const isSentryEnabled = (MODE: string | undefined) => {
  return MODE !== Mode.DEVELOPMENT
}

/* Функция для lazy load загрузки плагинов для sentry */
export async function getSentryIntegrations({ router }: { router: Router }) {
  const { replayIntegration, browserTracingIntegration } =
    await import('@sentry/vue')

  // Плагин для записи ошибки на клиенте
  Sentry.addIntegration(
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  )

  // Плагин для трейсинга браузера
  Sentry.addIntegration(
    browserTracingIntegration({
      router,
    }),
  )
}
